<template>
  <div class="pack-import-tree">
    <div class="text-muted small text-uppercase mb-50">Структура</div>

    <div
      v-for="(round, roundIndex) in rounds"
      :key="`round-${roundIndex}`"
      class="mb-1"
    >
      <div class="font-weight-bold mb-25">
        {{ round.name || `Раунд ${roundIndex + 1}` }}
        <b-badge v-if="round.is_final" variant="light-warning" class="ml-25">финал</b-badge>
      </div>

      <div
        v-for="(theme, themeIndex) in round.themes"
        :key="`theme-${roundIndex}-${themeIndex}`"
        class="tree-theme d-flex align-items-center"
        :class="{ 'tree-theme-active': isSelected(roundIndex, themeIndex) }"
        @click="$emit('select', { roundIndex, themeIndex })"
      >
        <span class="tree-theme-name">{{ theme.name || 'Без названия' }}</span>
        <small class="text-muted ml-50 text-nowrap">· {{ mechanicName(theme.mechanic_id) }}</small>
        <span
          v-if="themeHasIssues(roundIndex, themeIndex)"
          class="ml-auto pl-50 text-warning"
          title="Есть вопросы без механики или без привязок"
        >⚠</span>
        <span v-else class="ml-auto pl-50 text-success">✓</span>
      </div>
    </div>
  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
  components: { BBadge },
  props: {
    // rounds черновика импорта
    rounds: { type: Array, default: () => [] },
    // {roundIndex, themeIndex} выбранной темы
    selected: { type: Object, default: null },
    // {id: mechanic}
    mechanicsById: { type: Object, default: () => ({}) },
    // {'r-t': true} — темы с вопросами без механики или без привязок
    issuesByTheme: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const isSelected = (roundIndex, themeIndex) => Boolean(props.selected)
      && props.selected.roundIndex === roundIndex
      && props.selected.themeIndex === themeIndex

    const mechanicName = mechanicId => {
      if (mechanicId === null || mechanicId === undefined) return '—'
      const mechanic = props.mechanicsById[mechanicId]

      return mechanic ? mechanic.name : `#${mechanicId}`
    }

    const themeHasIssues = (roundIndex, themeIndex) => Boolean(props.issuesByTheme[`${roundIndex}-${themeIndex}`])

    return { isSelected, mechanicName, themeHasIssues }
  },
}
</script>

<style scoped>
.tree-theme {
  padding: 0.25rem 0.5rem 0.25rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
}
.tree-theme:hover {
  background: rgba(115, 103, 240, 0.06);
}
.tree-theme-active {
  background: rgba(115, 103, 240, 0.12);
}
.tree-theme-name {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
